import React, { Fragment } from 'react'
import { Intro, ClickAndReveal, Voiceover } from 'cvs-core'
import image from '../../assets/images/U2-T1-1-7a.svg'
import img1 from '../../assets/images/U2-T1-1-7b.svg'
import img2 from '../../assets/images/U2-T1-1-7c.svg'
import img3 from '../../assets/images/U2-T1-1-7d.svg'
import img4 from '../../assets/images/U2-T1-1-7e.svg'
import img5 from '../../assets/images/U2-T1-1-7f.svg'
import voAudio from '../../assets/vo/CVS-HS-SPM-Learn-03-01.mp3'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'Spending time on social media might be something you do for multiple hours a day. Let’s explore this screen to see how critically you observe your social media accounts and whether you know the tools to control what information you see.',
}

const data = [
  {
    x: 50,
    y: 50,
    name: 'Targeted Advertising',
    modal: {
      title: 'Targeted Advertising',
      text: (
        <p>
          Research by Stanford University has shown that teens who are exposed
          to social media posts featuring vaping are more likely to use
          e-cigarettes. Even just a short viewing has been shown to affect
          teens’ decision making. So, if social media feeds are filled with ads
          and posts about e-cigarettes that target 13–17-year-olds, it could
          have a serious impact on the number of teens who vape.
        </p>
      ),
      image: img1,
      imageText: 'Targeted Advertising',
    },
  },
  {
    x: 73,
    y: 34,
    name: 'Be a Critical Observer',
    modal: {
      title: 'Be a Critical Observer',
      text: (
        <p>
          If you choose to use social media, it’s important that you know you
          are in control of what you see. For example, if you notice that you’re
          seeing ads for products you are not interested in, such as
          e-cigarettes, on Instagram, you can tap the top right of the post and
          click “hide ad.” You will then be able to tell them why you don’t want
          to see ads like this to help determine what you see in the future.
        </p>
      ),
      image: img2,
      imageText: 'Be a Critical Observer',
    },
  },
  {
    x: 70,
    y: 90,
    name: 'Be an Informed Consumer',
    modal: {
      title: 'Be an Informed Consumer',
      text: (
        <p>
          Many social media platforms also allow you to control what you see
          through the Settings menu. You can also “mute” or “unfollow” anyone
          who posts often about things that are dangerous or can cause you harm,
          like vaping.
        </p>
      ),
      image: img3,
      imageText: 'Be an Informed Consumer',
    },
  },
  {
    x: 23,
    y: 42,
    name: 'Loopholes',
    modal: {
      title: 'Loopholes',
      text: (
        <p>
          Advertising e-cigarettes in traditional formats such as on radio,
          billboards, and TV commercials is prohibited by law, so vaping
          companies have gotten sneaky and started using digital outlets, like
          social media, to push their product. Even though companies like
          Instagram don’t allow vaping companies to pay for “promoted” posts,
          e-cigarette manufacturers can pay influencers to use and promote the
          product in their posts.
        </p>
      ),
      image: img4,
      imageText: 'Loopholes',
    },
  },
  {
    x: 24,
    y: 90,
    name: 'Teen Advocacy',
    modal: {
      title: 'Teen Advocacy',
      text: (
        <p>
          It’s important to remember that there are more teens who don’t vape
          than there are teens who do vape. Remember, in 2021, 88% of high
          school students and 93% of middle school students chose NOT to use
          e-cigarettes. Don’t interact with posts about vaping or e-cigarettes
          and keep the things you post about positive, healthy, and safe.
          Encourage your friends and followers to participate in activities that
          don’t involve potentially dangerous, unhealthy, or unsafe aspects, and
          remember—a picture is worth a thousand words! Posting pictures of you
          participating in fun and safe activities will encourage others to do
          the same.
        </p>
      ),
      image: img5,
      imageText: 'Teen Advocacy',
    },
  },
]

export default {
  title: 'Teens and social media',
  path: '/prepare/teens-and-social-media',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="Teens and social media"
        lead="Click each hotspot to see how critically you observe your social media accounts and whether you know the tools to control what information you see."
      />
      <ClickAndReveal
        backgroundImage={image}
        backgroundImageText="Background Placeholder"
        data={data}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Learn/TeensAndSocialMedia.js